// extracted by mini-css-extract-plugin
export var content = "_of-1";
export var fullScreen = "_of-0";